import { render, staticRenderFns } from "./AnomalyDescription.vue?vue&type=template&id=51895cb6&scoped=true&"
import script from "./AnomalyDescription.vue?vue&type=script&lang=js&"
export * from "./AnomalyDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51895cb6",
  null
  
)

export default component.exports